import _ from "lodash"
import store from "../store";
import FulfillmentMethods from "../data/fulfillmentMethods"
import DateHelper from "date-helper-util"
import countries from "../data/countries";
import mixin from "../mixin"
import orderListColumnTitles from "../data/orderListColumnTitles";
import refundRequestStatuses from "../data/refundRequestStatuses";
import axios from "axios";
import {downloadBase64url, downloadData, getDataURL} from "../helpers/download";
import moment from "moment";
import Vue from "vue";
import * as PermissionsHelper from "../helpers/permissions";
import {dispatchRequestStatus} from "../helpers/dispatch";
import {i18n} from "../main";

export default {
    preloadPromises: [],

    preload() {
        this.columns.forEach(column => {
            if (typeof column.preload === 'function') {
                let ret = column.preload
                if (ret instanceof Promise) {
                    this.preloadPromises.push(ret)
                }
            }
        })
    },

    isPreloaded() {
        return Promise.all(this.preloadPromises)
    },

    dispatchTypes: {},

    getColumnsWithActiveState(...columnIdentifiers) {
        return this.columns
            .map(column => {
                column.is_active = columnIdentifiers.indexOf(column.identifier) !== -1
                return column
            })
    },

    batchActionsPerSearchType: {
        global: {

        },
        pick_by_store: {
            download_packing_slips: {
                title: () => i18n.t('omt.gui.orders.search.batch-actions.download-packing-slips'),
                show: () => PermissionsHelper.hasPermission('orders.dispatchrequests.downloadpackingslip'),
                execute: async selectedOrders => {
                    return axios.get(`/api/rest/dispatch-requests/batch-packing-slips`, {
                        params: {
                            identifiers: selectedOrders.map(order => order.dispatch_requests[0].identifier).join(',')
                        },
                    })
                        .then(response => {
                            const identifier = moment().unix()

                            if (response.data.errors.length) {
                                Vue.prototype.$alert(`De volgende fouten zijn opgetreden bij het samenvoegen van de pakbonnen:<br /><br />* ${response.data.errors.join('<br />* ')}`, 'warning', false)
                            }
                            if (response.data.packing_slips_content_base64) {
                                downloadBase64url(getDataURL(response.data.packing_slips_content_type, response.data.packing_slips_content_base64), `Packingslip-batch-${identifier}.pdf`)
                            }
                            if (response.data.labels_content_base64) {
                                downloadBase64url(getDataURL(response.data.labels_content_type, response.data.labels_content_base64), `Labels-batch-${identifier}.pdf`)
                            }
                        })
                },
            },
            print_packing_slips: {
                title: () => i18n.t('omt.gui.orders.search.batch-actions.print-packing-slips'),
                show: () => PermissionsHelper.hasPermission('orders.dispatchrequests.printlabels') && !PermissionsHelper.hasPermission('canmanagealllocations'),
                execute: async selectedOrders => {
                    return axios.get(`/api/rest/dispatch-requests/batch-packing-slips`, {
                        params: {
                            identifiers: selectedOrders.map(order => order.dispatch_requests[0].identifier).join(','),
                            auto_print_label: 1,
                            auto_print_packing_slip: 0,
                        },
                    })
                        .then(response => {
                            Vue.prototype.$alert(`De printopdracht is verstuurd`, 'info')
                        })
                },
            },
            print_packing_slips_placeholder: {
                title: () => i18n.t('omt.gui.orders.search.batch-actions.print-packing-slips'),
                show: () => PermissionsHelper.hasPermission('orders.dispatchrequests.printlabels') && PermissionsHelper.hasPermission('canmanagealllocations'),
                execute: async selectedOrders => {
                    Vue.prototype.$alert("Deze knop doet niks omdat je de de permissie `canmanagealllocations` hebt", 'info')
                },
            },
        },
    },

    columns: [
        {
            identifier: 'orderIdentifier',
            name: orderListColumnTitles['order_identifier'],
            property: 'order_identifier',
            postProcess: (val) => val,
            is_active: true,
        },
        {
            identifier: 'placed_at',
            name: orderListColumnTitles['placed_at'],
            property: 'placed_at',
            postProcess: (val) => val,
            is_active: true,
            no_wrap: true,
        },
        {
            identifier: 'dispatchDate',
            name: orderListColumnTitles['dispatch_date'],
            property: 'dispatch_requests',
            postProcess: (dispatchRequests) => {
                try {
                    let maximumDispatchDate = DateHelper(new Date())
                    maximumDispatchDate.sub("day", 1)

                    if (
                        (
                            (
                                dispatchRequests[0].dispatcher_type !== 'store'
                                && dispatchRequests[0].status === 'to-be-requested'
                            ) || (
                                dispatchRequests[0].dispatcher_type === 'store'
                                && dispatchRequests[0].status === 'requested'
                            )
                        )
                        && maximumDispatchDate.isAfter(
                            DateHelper(dispatchRequests[0].dispatch_date, 'YYYY-MM-DD').getDateObject()
                        )
                    ) {
                        return `
                            <abbr title="Levering te laat" class="fas fa-exclamation-triangle text-danger"></abbr>
                            ${dispatchRequests[0].dispatch_date}
                        `
                    }

                    return dispatchRequests[0].dispatch_date
                } catch (e) {
                    return (typeof dispatchRequests[0] === 'object')
                        ? dispatchRequests[0].dispatch_date
                        : ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'drqStatus',
            name: orderListColumnTitles['dispatch_request_status'],
            property: 'dispatch_requests',
            postProcess: (dispatchRequests) => {
                try {
                    return dispatchRequestStatus(dispatchRequests[0].status)
                } catch (e) {
                    return 'Onbekend'
                }
            },
            is_active: false,
        },
        {
            identifier: 'orderPriceTotal',
            name: orderListColumnTitles['grand_total'],
            property: 'grand_total',
            postProcess: (val) => {
                val = mixin.filters.price(val)
                return val
            },
            is_active: true,
        },
        {
            identifier: 'paymentMethod',
            name: orderListColumnTitles['payment_method'],
            property: 'payments',
            preload: store.getters.getPaymentMethodsInformation,
            postProcess: (payments) => {
                try {
                    return payments?.map(p => {
                        return store.getters.paymentMethodOptions.find(m => m.id === p.payment_service_provider_account_method_id?.toString())?.display_name ?? p.payment_service_provider_account_method_id
                    }).filter().join("<br/>")
                }
                catch(e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'carrierMethod',
            name: orderListColumnTitles['carrier_method'],
            property: 'dispatch_requests', 
            postProcess: (drqs) => {
                return _.chain(drqs)
                    .map(drq => `${drq.carrier_method?.display_name ?? ''}`)
                    .uniq()
                    .join("<br/>")
                    .value()
            },
            is_active: false,
        },
        {
            identifier: 'productCount',
            name: 'Aantal producten',
            property: 'sales_order_lines',
            postProcess: (val) => {
                return _.sumBy(val, line => line.quantity)
            },
            is_active: false,
        },
        {
            identifier: 'dispatchType',
            name: orderListColumnTitles['dispatch_type'],
            property: 'dispatch_requests',
            preload: store.getters.getDispatchTypes,
            postProcess: (dispatchRequests) => {
                try {
                    return store.state.dispatchTypes[dispatchRequests[0].dispatch_type].display_name
                     + ((dispatchRequests[0].auto_purchase) ? ' (automatisch)' : '')
                } catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'dispatcherType',
            name: orderListColumnTitles['dispatcher_type'],
            property: 'dispatch_requests',
            preload: store.getters.getLocationDataTypes,
            postProcess: (dispatchRequests) => {
                try {
                    return mixin.filters.dispatcherType(dispatchRequests[0].dispatcher_type)
                } catch (e) {
                    return ''
                }
            },
            is_active: true,
        },
        {
            identifier: 'dispatcher',
            name: orderListColumnTitles['dispatcher'],
            property: 'dispatch_requests',
            preload: store.getters.getAllLocations,
            postProcess: (dispatchRequests) => {
                try {
                    return store.state.allLocations
                        .find(location =>
                            location.location_type.identifier === dispatchRequests[0].dispatcher_type
                            && location.identifier === dispatchRequests[0].dispatcher_identifier
                        )?.display_name
                } catch (e) {
                    return ''
                }
            },
            is_active: true,
        },
        {
            identifier: 'dispatcher',
            name: orderListColumnTitles['dispatcher_responsible'],
            property: 'dispatch_requests',
            preload: store.getters.getLocationsForUser,
            postProcess: (dispatchRequests) => {
                try {
                    return store.state.locationsForUser
                        .find(location => location.id === dispatchRequests[0].responsible_location_id
                        )?.display_name
                } catch (e) {
                    return ''
                }
            },
            is_active: true,
        },
        {
            identifier: 'fulfilmentMethod',
            name: orderListColumnTitles['fulfilment_method'],
            property: 'fulfilment_method',
            postProcess: (val) => {
                return (FulfillmentMethods[val]) ? FulfillmentMethods[val] : ''
            },
            is_active: true,
        },
        {
            identifier: 'holdStatus',
            name: orderListColumnTitles['hold_status'],
            property: 'dispatch_requests',
            postProcess: (dispatchRequests) => {
                try {
                    return dispatchRequestStatus(dispatchRequests[0].status)
                } catch (e) {
                    return ''
                }
            },
            is_active: true,
        },
        {
            identifier: 'promisedDeliveryDate',
            name: orderListColumnTitles['promised_delivery_date'],
            property: 'promised_delivery_date',
            postProcess: (val) => val,
            is_active: false,
        },
        {
            identifier: 'salesFormulaIdentifier',
            name: orderListColumnTitles['sales_formula_identifier'],
            property: 'sales_formula_identifier',
            postProcess: (val) => {
                try {
                    return val
                }
                catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'salesChannelIdentifier',
            name: orderListColumnTitles['sales_channel_identifier'],
            property: 'sales_channel_identifier',
            postProcess: (val) => {
                try {
                    return val
                }
                catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'customerName',
            name: orderListColumnTitles['customer_name'],
            property: 'addresses',
            postProcess: (val) => {
                try {
                    return val.billing.full_name
                } catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'customerCity',
            name: orderListColumnTitles['customer_city'],
            property: 'addresses',
            postProcess: (val) => {
                try {
                    return val.billing.city
                } catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'customerZipcode',
            name: orderListColumnTitles['address_zipcode'],
            property: 'addresses',
            postProcess: (val) => {
                try {
                    return val.billing.zipcode
                } catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'customerEmail',
            name: orderListColumnTitles['customer_email'],
            property: 'addresses',
            postProcess: (val) => {
                try {
                    return val.billing.email_address
                } catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'customerCountry',
            name: orderListColumnTitles['customer_country'],
            property: 'addresses',
            postProcess: (val) => {
                return countries[val.billing.country] ?? val.billing.country
            },
            is_active: false,
        },
        {
            identifier: 'customerNumber',
            name: orderListColumnTitles['customer_number'],
            property: 'customer_identifier',
            postProcess: (val) => val,
            is_active: false,
        },
        {
            identifier: 'refundStatus',
            name: orderListColumnTitles['refund_status'],
            property: 'refund_requests',
            postProcess: (val) => {
                try {
                    return val.map(rrq => refundRequestStatuses[rrq.status]).join(', ')
                } catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'countDrqs',
            name: orderListColumnTitles['count_drqs'],
            property: 'dispatch_requests',
            postProcess: (val) => {
                return val.length
            },
            is_active: false,
        },
        {
            identifier: 'validationStatus',
            name: orderListColumnTitles['validation_status'],
            property: 'validation_status',
            postProcess: (val) => {
              if (val !== '') {
                return `omt.gui.orders.search.results.validation-status.${val}`
              }
              return ''
            },
            is_active: true,
        },
        {
            identifier: 'drqBatch',
            name: orderListColumnTitles['dispatch_request_batch_identifier'],
            property: 'dispatch_requests',
            postProcess: (dispatchRequests) => {
                try {
                    return dispatchRequests[0]['dispatch_request_batch']['identifier']
                } catch (e) {
                    return ''
                }
            },
            is_active: false,
        },
        {
            identifier: 'assignError',
            name: orderListColumnTitles['has_assign_error'],
            property: 'is_dispatch_assign_retryable',
            postProcess: (value) => {
                const mapValueToFilterValue = {
                    undefined: "0",
                    null: "0",
                    true: "1",
                    false: "2",
                }

                return i18n.t(`omt.gui.orders.search.results.has-assign-error.${mapValueToFilterValue[value]}`)
            },
            is_active: false,
        },
    ]
}
